export default String.raw`
$(document).ready(()=>{
    new Swiper(".news__swiper", {
        navigation: {
            nextEl: '.news__arrows-next',
            prevEl: '.news__arrows-prev',
        },
        centerInsufficientSlides: true,
        breakpoints: {
            0: {
                spaceBetween: 16,
                slidesPerView: 1.5
            },

            769: {
                spaceBetween: 24,
                slidesPerView: 2.5
            },

            1440: {
                spaceBetween: 24,
                slidesPerView: 4
            }
        },
        a11y: false,
        keyboard: {
            enabled: true,
            pageUpDown: true
        },
        watchSlidesProgress: true,
        on: {
            init: function () {
                app.manageTabIndexInsideSlide(this);
            },
            slideChangeTransitionEnd: function () {
                app.manageTabIndexInsideSlide(this);
            }
        },
    });
});
`